<form
  [formGroup]="queryForm"
  (ngSubmit)="addQuery()"
  enctype="multipart/form-data"
>
  <div class="col-md-12">
    <div class="row">
      <div class="col-md-6 gifts-form">
        <div class="bg-main pt-3 pb-3 height-same-req">
          <div class="col-md-12 font-weight-bold mb-2 text-color-second">
            <i class="fa fa-user h4"></i> User Details
          </div>
          <div class="form-group row" *ngIf="Empstatus==1">
            <label class="col-form-label col-md-5 col-sm-5"
              >Create On Behalf</label
            >
            <div class="col-md-7 col-sm-7 pull-right">
              <ui-switch
                size="small"
                [(ngModel)]="isbehalf"
                formControlName="is_behalf"
                (change)="is_on_behalf($event)"
              ></ui-switch>
            </div>
          </div>
          <ng-container *ngIf="isbehalf">
            <div class="form-group row">
              <label for="staticEmail" class="col-sm-5 col-form-label"
                >Employee Name <span class="text-danger">*</span></label
              >
              <div class="col-sm-7">
                <input
                  formControlName="emp_id"
                  (keyup)="getEmps($event)"
                  class="form-control2"
                  type="text"
                  placeholder="Employee Search"
                />
                <select
                  class="form-control2"
                  (change)="selectEmp($event)"
                  *ngIf="searchEmps.length > 0 && emp_id"
                >
                  <option value="">Select</option>
                  <option [value]="list.id" *ngFor="let list of searchEmps">
                    {{ list.username }} - {{ list.name }}
                  </option>
                </select>

                <div
                  *ngIf="submitted && queryCont.emp_id.errors"
                  class="form-error"
                >
                  <div *ngIf="queryCont.emp_id.errors.required">
                    User is required !
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label for="staticEmail" class="col-sm-5 col-form-label"
                >Mobile No.</label
              >
              <div class="col-sm-7" *ngIf="userContact">
                <ul style="padding: 0px">
                  <li>{{ userContact.cont_1 }}</li>
                </ul>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="!isbehalf">
            <div class="form-group row">
              <label class="col-sm-5 col-form-label"
                >Employee Name <span class="form-error">*</span></label
              >
              <div class="col-sm-7">
                <input
                  type="text"
                  class="form-control2"
                  readonly
                  disabled
                  value="{{ Empname }}"
                />
              </div>
            </div>

            <div class="form-group row">
              <label for="staticEmail" class="col-sm-5 col-form-label"
                >Mobile No.</label
              >
              <div class="col-sm-7" *ngIf="userContact">
                <ul style="padding: 0px">
                  <li>{{ userContact.cont_1 }}</li>
                </ul>
              </div>
            </div>
          </ng-container>
          <section *ngIf="isbehalf">
            <div class="form-group row">
              <div class="col-sm-4 col-form-label">Bulk Query Generate</div>
              <div class="col-sm-4">
                <a href="assets/bulk_query_format.xlsx" style="color: black">
                  <button type="button" class="btn btn-sm btn-primary">
                    Download Format
                  </button>
                </a>
              </div>
              <div class="col-sm-4">
                <input
                  type="file"
                  class="btn btn-default"
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  (change)="excelRead($event)"
                  #myInput
                />
              </div>
            </div>
          </section>
        </div>
      </div>

      <div class="col-md-6 gifts-form">
        <div class="bg-main pt-3 pb-3 height-same-req">
          <div class="col-md-12 font-weight-bold mb-2 text-color-second">
            <i class="fa fa-question-circle h4"></i> Problem Details
          </div>
          <!-- <div class="form-group row">
            <label for="staticEmail" class="col-sm-5 col-form-label"
              >Org <span class="text-danger">*</span></label
            >
            <div class="col-sm-7">
              <select
                id="inputState"
                class="form-control2"
                formControlName="org_id"
                (change)="getCate($event)"
              >
                <option value="" selected>Select</option>
                <option value="{{ data.org_id }}" *ngFor="let data of orgList">
                  {{ data.org_name }}
                </option>
              </select>
              <div
                *ngIf="submitted && queryCont.org_id.errors"
                class="form-error"
              >
                <div *ngIf="queryCont.org_id.errors.required">Org Required</div>
              </div>
            </div>
          </div> -->
          <div class="form-group row">
            <label for="staticEmail" class="col-sm-5 col-form-label"
              >Query Category <span class="text-danger">*</span></label
            >
            <div class="col-sm-7">
              <select
                id="inputState"
                class="form-control2"
                formControlName="category"
                (change)="onChangeCategory($event)"
              >
                <option selected>Select...</option>
                <option
                  value="{{ data.cat_id }}"
                  *ngFor="let data of categList"
                >
                  {{ data.cat_desc }}
                </option>
              </select>
              <div
                *ngIf="submitted && queryCont.category.errors"
                class="form-error"
              >
                <div *ngIf="queryCont.category.errors.required">
                  Query Category Required
                </div>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <label for="staticEmail" class="col-sm-5 col-form-label"
              >Query Sub Category <span class="text-danger">*</span></label
            >
            <div class="col-sm-7">
              <select
                id="inputState"
                class="form-control2"
                formControlName="sub_cat1"
                (change)="mandateDoc()"
              >
                <option selected>Select...</option>
                <option
                  value="{{ data.subcat1_id }}"
                  *ngFor="let data of subCategList"
                >
                  {{ data.subcat1_desc }}
                </option>
              </select>
              <div
                *ngIf="submitted && queryCont.sub_cat1.errors"
                class="form-error"
              >
                <div *ngIf="queryCont.sub_cat1.errors.required">
                  Query Sub Category Required
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ng-container *ngIf="userDetailsForm">
      <div class="gifts-form">
        <div class="bg-main pt-3 pb-3 height-same-req">
          <div class="col-md-12 font-weight-bold mb-2 text-color-second">
            <h3 class="card-title page-header0">
              <i class="fa fa-book"></i>&nbsp;User Details:
            </h3>
            <hr />
            <!-- <div class="row"> -->

            <div class="form-group row">
              <label class="col-sm-5 col-form-label"
                >Account Type <span class="form-error">*</span></label
              >
              <div class="col-sm-7">
                <select class="form-control2" formControlName="acc_type">
                  <option value="">Select Account Type</option>
                  <option [value]="item.value" *ngFor="let item of getAccType">
                    {{ item.label }}
                  </option>
                </select>
                <div
                  *ngIf="submitted && queryCont.acc_type.errors"
                  class="form-error"
                >
                  <div *ngIf="queryCont.acc_type.errors.required">
                    Account Type is required
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-5 col-form-label"
                >Bank Name <span class="form-error">*</span></label
              >
              <div class="col-sm-7">
                <select class="form-control2" formControlName="bank_id">
                  <option value="">Select Bank</option>
                  <option [value]="item.value" *ngFor="let item of getBankName">
                    {{ item.label }}
                  </option>
                </select>
                <div
                  *ngIf="submitted && queryCont.bank_id.errors"
                  class="form-error"
                >
                  <div *ngIf="queryCont.bank_id.errors.required">
                    Bank Name is required
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-5 col-form-label"
                >Account No <span class="form-error">*</span></label
              >
              <div class="col-sm-7">
                <input
                  type="text"
                  class="form-control2"
                  formControlName="acc_no"
                />
                <div
                  *ngIf="
                    (submitted || queryCont.acc_no.touched) &&
                    queryCont.acc_no.errors
                  "
                  class="form-error"
                >
                  <div *ngIf="queryCont.acc_no.errors.required">
                    Account No is required
                  </div>
                  <!-- <div *ngIf="queryCont.acc_no.errors.minlength">Account No must be of 12 characters</div>
                                            <div *ngIf="queryCont.acc_no.errors.maxlength">Account No must be of 12 characters</div>
                                            <div *ngIf="queryCont.acc_no.errors.pattern">Enter only number.</div> -->
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-5 col-form-label"
                >IFSC Code <span class="form-error">*</span></label
              >
              <div class="col-sm-7">
                <input
                  type="text"
                  class="form-control2"
                  formControlName="ifsc_code"
                  minlength="11"
                  maxlength="11"
                />
                <div
                  *ngIf="submitted && queryCont.ifsc_code.errors"
                  class="form-error"
                >
                  <div *ngIf="queryCont.ifsc_code.errors.required">
                    IFSC Code is required
                  </div>
                  <div *ngIf="queryCont.ifsc_code.errors.maxlength">
                    IFSC Code must be of 11 characters
                  </div>
                  <div *ngIf="queryCont.ifsc_code.errors.minlength">
                    IFSC Code must be of 11 characters
                  </div>
                </div>
              </div>
            </div>

            <!-- </div>end of row -->
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="reiumbureseBankForm">
      <div class="gifts-form">
        <div class="bg-main pt-3 pb-3 height-same-req">
          <div class="col-md-12 font-weight-bold mb-2 text-color-second">
            <h3 class="card-title page-header0">
              <i class="fa fa-book"></i>&nbsp; Employee Reimbursement Bank
              Details :
            </h3>
            <hr />
            <!-- <div class="row"> -->

            <div class="form-group row">
              <label class="col-sm-5 col-form-label"
                >Account Type <span class="form-error">*</span></label
              >
              <div class="col-sm-7">
                <select class="form-control2" formControlName="rem_acc_type">
                  <option value="">Select Account Type</option>
                  <option [value]="item.value" *ngFor="let item of getAccType">
                    {{ item.label }}
                  </option>
                </select>
                <div
                  *ngIf="submitted && queryCont.rem_acc_type.errors"
                  class="form-error"
                >
                  <div *ngIf="queryCont.rem_acc_type.errors.required">
                    Account Type is required
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <label class="col-sm-5 col-form-label"
                >Bank Name <span class="form-error">*</span></label
              >
              <div class="col-sm-7">
                <select class="form-control2" formControlName="rem_bank_id">
                  <option value="">Select Bank</option>
                  <option [value]="item.value" *ngFor="let item of getBankName">
                    {{ item.label }}
                  </option>
                </select>
                <div
                  *ngIf="submitted && queryCont.rem_bank_id.errors"
                  class="form-error"
                >
                  <div *ngIf="queryCont.rem_bank_id.errors.required">
                    Bank Name is required
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <label class="col-sm-5 col-form-label"
                >Account No <span class="form-error">*</span></label
              >
              <div class="col-sm-7">
                <input
                  type="text"
                  class="form-control2"
                  formControlName="rem_acc_no"
                />
                <div
                  *ngIf="
                    (submitted || queryCont.rem_acc_no.touched) &&
                    queryCont.rem_acc_no.errors
                  "
                  class="form-error"
                >
                  <div *ngIf="queryCont.rem_acc_no.errors.required">
                    Account No is required
                  </div>
                  <!-- <div *ngIf="queryCont.acc_no.errors.minlength">Account No must be of 12 characters</div>
                                            <div *ngIf="queryCont.acc_no.errors.maxlength">Account No must be of 12 characters</div>
                                            <div *ngIf="queryCont.acc_no.errors.pattern">Enter only number.</div> -->
                </div>
              </div>
            </div>
            <div class="row">
              <label class="col-sm-5 col-form-label"
                >IFSC Code <span class="form-error">*</span></label
              >
              <div class="col-sm-7">
                <input
                  type="text"
                  class="form-control2"
                  formControlName="rem_ifsc_code"
                  minlength="11"
                  maxlength="11"
                />
                <div
                  *ngIf="submitted && queryCont.rem_ifsc_code.errors"
                  class="form-error"
                >
                  <div *ngIf="queryCont.rem_ifsc_code.errors.required">
                    IFSC Code is required
                  </div>
                  <div *ngIf="queryCont.rem_ifsc_code.errors.maxlength">
                    IFSC Code must be of 11 characters
                  </div>
                </div>
              </div>
            </div>

            <!-- </div>end of row -->
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="userPersnalDetailsForm">
      <div class="col-md-12 gifts-form">
        <div class="bg-main pt-3 pb-3 height-same-req">
          <div class="col-md-12 font-weight-bold mb-2 text-color-second">
            <h3 class="card-title page-header0">
              <i class="fa fa-book"></i>&nbsp;User Personal Details: User
              details to be updated on Employee Master
            </h3>
            <hr />
            <div class="row">
              <div class="col-md-6">
                <div class="form-group row">
                  <label class="col-sm-5 col-form-label"
                    >Employee First Name
                  </label>
                  <div class="col-sm-7">
                    <input
                      type="text"
                      class="form-control2"
                      formControlName="first_name"
                    />
                    <div
                      *ngIf="submitted && queryCont.first_name.errors"
                      class="form-error"
                    >
                      <div *ngIf="queryCont.first_name.errors.required">
                        First Name is required
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group row">
                  <label class="col-sm-5 col-form-label"
                    >Employee Last Name
                  </label>
                  <div class="col-sm-7">
                    <input
                      type="text"
                      class="form-control2"
                      formControlName="last_name"
                    />
                    <div
                      *ngIf="submitted && queryCont.last_name.errors"
                      class="form-error"
                    >
                      <div *ngIf="queryCont.last_name.errors.required">
                        Last Name is required
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group row">
                  <label class="col-sm-5 col-form-label">Marital Status </label>
                  <div class="col-sm-7">
                    <select class="form-control2" formControlName="marital">
                      <option value="">Select Marital Status</option>
                      <option
                        value="{{ md.value }}"
                        *ngFor="let md of maritalData"
                      >
                        {{ md.label }}
                      </option>
                    </select>
                    <div
                      *ngIf="submitted && queryCont.marital.errors"
                      class="form-error"
                    >
                      <div *ngIf="queryCont.marital.errors.required">
                        Marital Status is required
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group row">
                  <label class="col-sm-5 col-form-label">Date Of Birth </label>
                  <div class="col-sm-7">
                    <input
                      type="date"
                      class="form-control2"
                      formControlName="dob"
                    />
                    <div
                      *ngIf="submitted && queryCont.dob.errors"
                      class="form-error"
                    >
                      <div *ngIf="queryCont.dob.errors.required">
                        DOB is required
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group row">
                  <label class="col-sm-5 col-form-label">Gender </label>
                  <div class="col-sm-7">
                    <select class="form-control2" formControlName="gender">
                      <option value="">Select Gender</option>
                      <option
                        value="{{ gend.value }}"
                        *ngFor="let gend of genderData"
                      >
                        {{ gend.label }}
                      </option>
                    </select>
                    <div
                      *ngIf="submitted && queryCont.gender.errors"
                      class="form-error"
                    >
                      <div *ngIf="queryCont.gender.errors.required">
                        Gender is required
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group row">
                  <label class="col-sm-5 col-form-label"
                    >Physical Disability
                  </label>
                  <div class="col-sm-7">
                    <select class="form-control2" formControlName="is_pwd">
                      <option value="">Select Physical Disability</option>
                      <option
                        value="{{ pwd.value }}"
                        *ngFor="let pwd of pwdData"
                      >
                        {{ pwd.label }}
                      </option>
                    </select>
                    <div
                      *ngIf="submitted && queryCont.is_pwd.errors"
                      class="form-error"
                    >
                      <div *ngIf="queryCont.is_pwd.errors.required">
                        Physical Disability is required
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group row">
                  <label class="col-sm-5 col-form-label">Department </label>
                  <div class="col-sm-7">
                    <select class="form-control2" formControlName="depart">
                      <option value="">Select Department</option>
                      <option
                        value="{{ dpt.value }}"
                        *ngFor="let dpt of departmentData"
                      >
                        {{ dpt.label }}
                      </option>
                    </select>
                    <div
                      *ngIf="submitted && queryCont.depart.errors"
                      class="form-error"
                    >
                      <div *ngIf="queryCont.depart.errors.required">
                        Department is required
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- </div>end of row -->
          </div>
        </div>
      </div>
    </ng-container>

    <div class="row">
      <div class="col-md-6 gifts-form">
        <div class="bg-main pt-3 pb-3 height-same-req">
          <div class="col-md-12 font-weight-bold mb-2 text-color-second">
            <i class="fa fa-pencil-square h4"></i> Document
          </div>
          <div class="form-group row">
            <label for="staticEmail" class="col-sm-5 col-form-label"
              >Priority <span class="text-danger">*</span></label
            >
            <div class="col-sm-7">
              <select
                id="inputState"
                class="form-control2"
                formControlName="priority"
              >
                <option value="low">Low</option>
                <option value="medium">Medium</option>
                <option value="high">High</option>
              </select>
              <div
                *ngIf="submitted && queryCont.priority.errors"
                class="form-error"
              >
                <div *ngIf="queryCont.priority.errors.required">
                  Priority Required
                </div>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <label for="staticEmail" class="col-sm-5 col-form-label"
              >Upload Document</label
            >
            <div class="col-sm-7">
              <input
                type="file"
                class="form-control2"
                formControlName="doc"
                (change)="onFileChange($event)"
                id=""
              />
              <div *ngIf="submitted && queryCont.doc.errors" class="form-error">
                <div *ngIf="queryCont.doc.errors.required">**Docs Required</div>
              </div>
              <p class="text-danger mb-0">
                Please upload only pdf,MS word file,gif,jpg & png.For ID
                card(Upload your passport size photo with clean background)
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6 gifts-form">
        <div class="bg-main pt-3 pb-3 height-same-req">
          <div class="col-md-12 font-weight-bold mb-2 text-color-second">
            <i class="fa fa-commenting h4"></i> Comments:
          </div>
          <div class="form-group row">
            <div class="col-sm-12">
              <textarea
                class="form-control fs-12"
                id="exampleFormControlTextarea1"
                rows="3"
                formControlName="remark"
                placeholder="Enter Comments(Candidate Designation, Profile, Role suitability, Site Mapping and Location)"
              ></textarea>
              <div
                *ngIf="submitted && queryCont.remark.errors"
                class="form-error"
              >
                <div *ngIf="queryCont.remark.errors.required">
                  Comments Required
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12 mt-4 text-center">
        <button
          type="submit"
          class="btn btn-primary btn-padding1 border-0 bg-main2"
          [disabled]="loading"
        >
          <span
            *ngIf="loading"
            class="spinner-border spinner-border-sm mr-1"
          ></span
          ><i class="fa fa-save"></i> Create Query
        </button>
      </div>
    </div>
  </div>
</form>
